var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 24,
    viewBox: "0 0 64 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7582_14899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1223 -0.320312H49.8663V24.332H14.1321L14.1223 -0.320312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.749 13.3906C49.749 13.3906 39.9819 20.8517 22.0951 24.1979H49.749V13.3906Z",
    fill: "#F48120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8671 -0.46666H14V24.4728H50V-0.476562H49.8671V-0.46666ZM49.7441 -0.189395C49.7441 0.0878708 49.7441 23.9083 49.7441 24.1856C49.4881 24.1856 14.521 24.1856 14.2651 24.1856C14.2651 23.9083 14.2651 0.0878708 14.2651 -0.189395C14.521 -0.189395 49.479 -0.189395 49.7441 -0.189395Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1501 7.1582H15.663V12.8033H17.1501C17.9362 12.8033 18.5051 12.5984 19.0071 12.1566C19.604 11.6226 19.9542 10.8221 19.9542 9.99104C19.9451 8.3183 18.799 7.1582 17.1501 7.1582ZM18.344 11.4071C18.022 11.7148 17.6149 11.8588 16.9512 11.8588H16.6769V8.1233H16.9519C17.6058 8.1233 18.0037 8.2467 18.3447 8.575C18.6956 8.91397 18.9037 9.43727 18.9037 9.98113C18.903 10.525 18.6942 11.0689 18.344 11.4071Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4338 7.1582H20.4199V12.8033H21.4338V7.1582Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9131 9.32477C23.307 9.07873 23.127 8.9142 23.127 8.61637C23.127 8.25684 23.4491 7.99023 23.885 7.99023C24.188 7.99023 24.444 8.12353 24.6999 8.45184L25.2308 7.7023C24.7948 7.29174 24.2738 7.07617 23.6959 7.07617C22.7769 7.07617 22.0667 7.77391 22.0667 8.69787C22.0667 9.47787 22.3986 9.87777 23.3457 10.248C23.7437 10.4018 23.9427 10.5047 24.0467 10.5664C24.2457 10.7103 24.3498 10.9152 24.3498 11.1514C24.3498 11.613 24.0179 11.9519 23.5637 11.9519C23.0806 11.9519 22.6918 11.6853 22.4555 11.2024L21.8016 11.8902C22.2657 12.6398 22.8345 12.9681 23.6016 12.9681C24.6535 12.9681 25.4016 12.2086 25.4016 11.1102C25.4199 10.1969 25.0691 9.78637 23.9131 9.32477Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7269 9.99215C25.7269 11.655 26.93 12.9377 28.474 12.9377C28.91 12.9377 29.289 12.8455 29.7432 12.6094V11.316C29.3361 11.7571 28.9761 11.9315 28.5211 11.9315C27.4981 11.9315 26.7683 11.1309 26.7683 9.98148C26.7683 8.89375 27.5164 8.04139 28.4733 8.04139C28.9564 8.04139 29.3262 8.22649 29.7425 8.67742V7.38402C29.2974 7.13799 28.9276 7.03516 28.4916 7.03516C26.9679 7.03592 25.7269 8.34988 25.7269 9.99215Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8149 10.9554L36.422 7.1582H35.3138L37.521 12.9465H38.0708L40.3159 7.1582H39.2169L37.8149 10.9554Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7799 12.8033H43.6599V11.8489H41.7938V10.33H43.5938V9.37481H41.7938V8.1233H43.6599V7.1582H40.7799V12.8033Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6915 8.83275C47.6915 7.77549 47.0186 7.16992 45.8444 7.16992H44.3383V12.815H45.3522V10.5466H45.4851L46.8871 12.815H48.138L46.499 10.4339C47.2654 10.2595 47.6915 9.69502 47.6915 8.83275ZM45.6454 9.76662H45.3515V8.05275H45.6644C46.2993 8.05275 46.6404 8.33992 46.6404 8.89445C46.6404 9.45889 46.2993 9.76662 45.6454 9.76662Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8561 13.0087C34.3892 13.0087 35.632 11.6623 35.632 10.0014C35.632 8.34054 34.3892 6.99414 32.8561 6.99414C31.323 6.99414 30.0801 8.34054 30.0801 10.0014C30.0801 11.6623 31.323 13.0087 32.8561 13.0087Z",
    fill: "url(#paint0_linear_7582_14899)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M32.8561 13.0087C34.3892 13.0087 35.632 11.6623 35.632 10.0014C35.632 8.34054 34.3892 6.99414 32.8561 6.99414C31.323 6.99414 30.0801 8.34054 30.0801 10.0014C30.0801 11.6623 31.323 13.0087 32.8561 13.0087Z",
    fill: "url(#paint1_linear_7582_14899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3418 7.37262C48.3418 7.26979 48.2757 7.21875 48.1709 7.21875H48.019V7.71158H48.1329V7.51658L48.2658 7.71158H48.3987L48.2469 7.50668C48.3038 7.49602 48.3418 7.44422 48.3418 7.37262ZM48.1519 7.44422H48.1329V7.31092H48.1519C48.2089 7.31092 48.237 7.33148 48.237 7.37262C48.237 7.42365 48.2089 7.44422 48.1519 7.44422Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1847 7.03516C47.9667 7.03516 47.7867 7.23016 47.7867 7.46629C47.7867 7.70242 47.9667 7.89742 48.1847 7.89742C48.4026 7.89742 48.5826 7.70242 48.5826 7.46629C48.5826 7.23016 48.4026 7.03516 48.1847 7.03516ZM48.1847 7.82582C48.0138 7.82582 47.8626 7.67195 47.8626 7.46629C47.8626 7.27129 48.0047 7.10676 48.1847 7.10676C48.3555 7.10676 48.4975 7.27129 48.4975 7.46629C48.4975 7.66129 48.3555 7.82582 48.1847 7.82582Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7582_14899",
    x1: 34.2749,
    y1: 12.4081,
    x2: 32.1308,
    y2: 9.30933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    stopColor: "#F79A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#F68D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7582_14899",
    x1: 33.9719,
    y1: 12.3643,
    x2: 30.7951,
    y2: 6.63264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    stopColor: "#E16F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D4602C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#D05B2E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7582_14899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "white",
    transform: "translate(14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.bf865ad66e1ffb9aebbecd93f107b1cf.svg";
export { ForwardRef as ReactComponent };